module.exports = __webpack_public_path__ + "img/ddbh.5e7c6b4e.svg";